  // Initial number
  let number = 103548;

  // Function to simulate backspacing and rewriting
  function updateNumber(newNumber) {
      const numberElement = document.getElementById('number');
      const currentNumber = numberElement.textContent.replace('|', ''); // Remove cursor if present
      const newNumberStr = newNumber.toLocaleString();

      // Backspace effect
      let i = currentNumber.length;
      const backspaceInterval = setInterval(() => {
          if (i >= 0) {
              numberElement.innerHTML = currentNumber.substring(0, i) + '<span class="cursor"></span>';
              i--;
          } else {
              clearInterval(backspaceInterval);

              // Rewrite the new number with blinking cursor
              let j = 0;
              const rewriteInterval = setInterval(() => {
                  if (j <= newNumberStr.length) {
                      numberElement.innerHTML = newNumberStr.substring(0, j) + '<span class="cursor"></span>';
                      j++;
                  } else {
                      clearInterval(rewriteInterval);
                  }
              }, 100); // Adjust speed of rewriting here
          }
      }, 100); // Adjust speed of backspacing here
  }

  // Function to increase the number
  function increaseNumber() {
      number += 1;
      updateNumber(number);
  }

  // Update the number every 19 seconds
  setInterval(increaseNumber, 19000); // Changed to 19000 milliseconds (19 seconds)